import { useLang } from "../../lib/i18n";
import { useContent } from "../../lib/useFetch";

export default function Privacy() {
  const { trc } = useLang();
  const c = useContent();
  if (!c.privacy) return <div className="h-screen" />;
  return (
    <article className="container-x max-w-3xl pb-24 pt-36" data-testid="privacy-page">
      <p className="eyebrow">GDPR · EU 2016/679</p>
      <h1 className="mt-4 font-display text-4xl font-extrabold text-[#0A2540] sm:text-5xl dark:text-white" data-testid="privacy-title">{trc(c, "privacy", "title")}</h1>
      <div className="mt-10 whitespace-pre-line text-base leading-relaxed text-slate-700 dark:text-slate-300" data-testid="privacy-body">{trc(c, "privacy", "body")}</div>
    </article>
  );
}
